import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const Account = lazy(() => import('components/Sections/Account'))
const Footer = lazy(() => import('components/Layout/Footer'))

function HomePage() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <Account />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default HomePage